<template>
  <div class="main-content">
    <!-- CARDS -->
    <div class="container-fluid">
      <!-- / .row -->
      <div class="row">
        <div class="col-12">
          <!-- Convertions -->
          <b-overlay :show="overlay" rounded="lg" >
            <div class="card mt-5">
              <div class="card-header h-auto">
                <div class="row">
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <small class="text-muted">NIK</small>
                    <p class="mb-0">{{detail.nik}}</p>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <small class="text-muted">Employee Name</small>
                    <p class="mb-0">{{detail.employee_name}}</p>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <small class="text-muted">Employee Position</small>
                    <p class="mb-0">{{detail.employee_position}}</p>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <small class="text-muted">Employee Department</small>
                    <p class="mb-0">{{detail.employee_department}}</p>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <small class="text-muted">Employee Company</small>
                    <p class="mb-0">{{detail.employee_company}}</p>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <small class="text-muted">Total Sick Leave</small>
                    <p class="mb-0">{{detail.total_absent}}</p>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="list-group list-group-flush list-group-activity my-n3">
                  <div class="list-group-item" v-for="(s, i) in detail.details" :key="i">
                    <div class="row">
                      <div class="col-auto">
                        <!-- Avatar -->
                        <div class="avatar avatar-sm">
                          <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                            <i class="fe fe-plus-square"></i>
                          </div>
                        </div>
    
                      </div>
                      <div class="col ms-n2">
                        <div class="card mb-0">
                          <div class="card-header h-auto">
                            <div class="row">
                              <div class="col-lg-4 col-md-6 col-sm-12">
                                <small class="text-muted">Healthcare Facility</small>
                                <p class="mb-0">{{s.healthcare_facility_name}}</p>
                              </div>
                              <div class="col-lg-4 col-md-6 col-sm-12">
                                <small class="text-muted">Registration ID</small>
                                <p class="mb-0">{{s.register_id}}</p>
                              </div>
                              <div class="col-lg-4 col-md-6 col-sm-12">
                                <small class="text-muted">Time</small>
                                <p class="mb-0">{{formatDate(s.updated_at)}}</p>
                              </div>
                            </div>
                          </div>
                          <div class="card-body">
                            <div class="row">
                              <div class="col-lg-4 col-md-6 col-sm-12 mb-3">
                                <small class="text-muted">Main Complaint</small>
                                <p class="mb-0">{{s.init_complaint}}</p>
                              </div>
                              <div class="col-lg-4 col-md-6 col-sm-12 mb-3">
                                <small class="text-muted">Vital Sign</small>
                                <p class="mb-0">{{s.vital_sign}}</p>
                              </div>
                              <div class="col-lg-4 col-md-6 col-sm-12 mb-3">
                                <small class="text-muted">Spell</small>
                                <p class="mb-0">{{s.spell ? 'Yes' : 'No'}}</p>
                              </div>
                              <div class="col-lg-4 col-md-6 col-sm-12 mb-3">
                                <small class="text-muted">PAK</small>
                                <p class="mb-0">{{s.pak ? 'Yes' : 'No'}}</p>
                              </div>
                              <div class="col-lg-4 col-md-6 col-sm-12 mb-3" v-if="s.doctor_action">
                                <small class="text-muted">Doctor Action</small>
                                <p class="mb-0">{{s.doctor_action}}</p>
                              </div>
                              <div class="col-lg-4 col-md-6 col-sm-12 mb-3" v-if="s.follow_up">
                                <small class="text-muted">Follow Up</small>
                                <p class="mb-0">{{followUp(s.follow_up)}}</p>
                              </div>
                              <div class="col-lg-4 col-md-6 col-sm-12 mb-3" v-if="parseInt(s.follow_up) == 2">
                                <small class="text-muted">Next Visit</small>
                                <p class="mb-0">{{s.next_visit}}</p>
                              </div>
                              <div class="col-lg-4 col-md-6 col-sm-12 mb-3">
                                <small class="text-muted">Doctor Notes</small>
                                <p class="mb-0">{{s.doctor_note || '-'}}</p>
                              </div>
                              <div class="col-lg-4 col-md-6 col-sm-12 mb-3">
                                <small class="text-muted">Sick Leave</small>
                                <p class="mb-0">{{s.sick_leave ? 'Yes' : 'No'}}</p>
                              </div>
                              <div class="col-lg-4 col-md-6 col-sm-12 mb-3">
                                <small class="text-muted">Sick Leave Day</small>
                                <p class="mb-0">{{`${s.sick_leave_day} ${s.sick_leave_day > 1 ? 'Days' : 'Day'}`}}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> <!-- / .row -->
                  </div>
                </div>
              </div>
            </div>
          </b-overlay>
        </div>
      </div>
      <!-- / .row -->
    </div>
  </div>
  <!-- / .main-content -->
</template>
<style>
  .myTable th, .myTable td {
    border: 1px solid black !important;
  }
</style>
<script>
import "../../assets/js/theme.bundle";
import "../../assets/js/vendor.bundle";
import moment from "moment";

export default {
  name: "sickLeaveList",
  computed: {
    detail() {
      return this.$store.getters["sick_leave/detail"];
    },
  },
  data() {
    return {
      searchTerm: "",
      pageLength: 10,
      params: {},
      overlay: true,
      details: {}
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      const id = this.$router.currentRoute.params["id"];
      console.log('id', id);
      this.$store.dispatch("sick_leave/DETAIL", id).finally(() => this.overlay = false)
    },
    formatNumber(n) {
      return n.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
    },
    formatDate(date) {
      if (date) {
        return moment(date).format("D MMM YYYY HH:mm:ss");
      }
      return date;
    },
    followUp(v) {
      switch (parseInt(v)) {
        case 1:
          return "No"
        case 2:
          return "Control"
        case 3:
          return "Treat Referral"
        default:
          return "No"
      }
    }
  },
};
</script>